import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {TooltipService} from "@irb-common/components/tooltip/tooltip.service";
import {MatDialogRef} from "@angular/material/dialog";
import {IrbOrdersService} from "@irb/irb-orders/irb-orders.service";
import {IrbAppEvents} from "@irb/app.events";
import {IAlertDialogData} from "@irb/app.model";
import {AppService} from "@irb/app.service";
import {formatOrderType, formatTransactionAction} from "@irb-common/formatters";
import { IDropdownItem } from '@irb/irb-common/models/dropdown.model';
import { IMasterAccount } from '../irb-orders.model';

@Component({ standalone: false,
  selector: 'irb-create-blocks-dialog',
  templateUrl: './create-blocks-dialog.component.html',
  styleUrls: ['./create-blocks-dialog.component.scss', '../../irb-common/styles/dialog.scss']
})
export class CreateBlocksDialogComponent implements OnInit {

  @Input()
  inventoryComponentRef: any = {};

  query: any = null;
  selectedArray: any[] = [];
  isSelecting = false;
  canNotContinue = true;
  showSpinner = false;
  step = 'intro';
  warningOrderCnt = 0;
  blockDeskContact = '800-766-9922'; // toDo: think of common source of this type of info
  unblockOrdersArr: any[] = [];
  combinedWarningTitle = '';
  combinedWarningMsg = '';
  combinedWarningAltMsg = '';
  combinedWarningCallbackFn: any;
  combinedWarningCancelCallbackFn: any;
  combinedWarningBtnTitle = '';
  combinedWarningCancelBtnTitle = '';
  progressTimer: any = null;
  btnRevertBlockShow = false;
  btnUnblockCancelShow = true;
  btnUnblockCloseShow = false;
  isShowProgressBarButtons = false;
  unblockGridOptions: any;
  unblockOrdersRowData: any;
  updateStatusCount = 0;

  thresholdConfigSettingsObj: any = {
    totalRecords: 0, // Total records at the time of landing page.
    isSelectAll: false, // Select all checked
    actionType: null, // Cancel, Block etc..
    selectedRecords: 0, // number of selected records
    idsInSession: 0, // number of ids in sessions
    thresholdCount: 0, // Threshold count get it from config and update
    isFilterAppliedCount: 0, // check records fetch by using filter
    isFilterApplied: false,
    query: [],
    Filter: [],
    deselectedIds: [],
    filterString: "",
    onSelectedDeselected: null,
    deselectedRecords: 0,
    mixedWithSelectedAll: false,
    isAbvTresholdFilterTrackEnabled: false, // Ids wont get from db if above limit. This flag is used in updateHeaderSelectorState() to execute condition for this scenario
    linkedFilterAction: false,
    currentStateCheckBox: false,
    thresholdMultiEditCount: 0 //IREBALUX-106

  };

  selectedMasterAccount: any;
  @ViewChild('masterAccountTemplateRef') masterAccountTemplateRef: any;
  masterAccountList:IMasterAccount[] = [];
  isUiTest = false;
  constructor(public dialogRef: MatDialogRef<CreateBlocksDialogComponent>,
              public irbOrderService: IrbOrdersService,
              public tts: TooltipService,
              public as: AppService
  ) { }

  ngOnInit(): void {
    this.getMasterAccount();
    if (!this.inventoryComponentRef) {
      this.inventoryComponentRef = {};
    }
    if (!this.inventoryComponentRef.params) {
      this.inventoryComponentRef.params = {};
    }
    if (!this.inventoryComponentRef.params.api) {
      this.inventoryComponentRef.params.api = {};
    }
    if (typeof this.inventoryComponentRef.params.api.getSelectedRows === 'function') {
      this.thresholdConfigSettingsObj.selectedRecords = this.inventoryComponentRef.params.api.getSelectedRows();
      this.thresholdConfigSettingsObj.totalRecords = this.inventoryComponentRef._totalRecords;
      this.thresholdConfigSettingsObj.isSelectAll = this.inventoryComponentRef.isSelectedAll;

      if(this.thresholdConfigSettingsObj.isSelectAll) {
        this.inventoryComponentRef.deselectedFromSelectAllRecords?.forEach((node: any) => {
          this.thresholdConfigSettingsObj.deselectedIds.push(node.orderID);
        });

        this.thresholdConfigSettingsObj.totalRecords -= this.thresholdConfigSettingsObj.deselectedIds.length;
        const filter = (this.inventoryComponentRef.pfs) ? this.inventoryComponentRef.pfs._filterCriteria: null;
        this.thresholdConfigSettingsObj.filterString = (filter != null) ? encodeURIComponent(filter) : '';
      }
    }
    if (this.inventoryComponentRef._thresholdConfigSettings) {
      this.thresholdConfigSettingsObj.thresholdCount = this.inventoryComponentRef._thresholdConfigSettings.OrderActionTreshold;
      this.thresholdConfigSettingsObj.thresholdMultiEditCount = this.inventoryComponentRef._thresholdConfigSettings.thresholdMultiEditCount;
    }
    this.unblockGridOptions = {
      rowModelType: 'clientSide',
      columnDefs: this.getUnblockColumnDefs(),
      rowSelection: 'multiple',
      floatingFilter: false,
      suppressHorizontalScroll: true
    };
    if (this.step === 'show-unblock-orders') {
      this.unblockOrdersInit();
    }
    this.combinedWarningCancelCallbackFn = function() {
      this.close();
    };
  }
  /**
   * @description sets Default settings for threholdConfigSettingsObj.
   */
  defaultSettingsThreshold(): void {
    this.thresholdConfigSettingsObj.totalRecords = 0; // Total records at the time of landing page.
    this.thresholdConfigSettingsObj.isSelectAll = false; // Select all checked
    this.thresholdConfigSettingsObj.actionType = null, // Cancel, Block etc..
    this.thresholdConfigSettingsObj.selectedRecords = 0; // number of selected records
    this.thresholdConfigSettingsObj.idsInSession = 0; // number of ids in sessions
    this.thresholdConfigSettingsObj.isFilterAppliedCount = 0; // check records fetch by using filter
    this.thresholdConfigSettingsObj.isFilterApplied = false;
    this.thresholdConfigSettingsObj.query = [];
    this.thresholdConfigSettingsObj.Filter = [];
    this.thresholdConfigSettingsObj.deselectedIds = [];
    this.thresholdConfigSettingsObj.filterString = "";
    this.thresholdConfigSettingsObj.onSelectedDeselected = null;
    this.thresholdConfigSettingsObj.deselectedRecords = 0;
    this.thresholdConfigSettingsObj.mixedWithSelectedAll = false;
    this.thresholdConfigSettingsObj.isAbvTresholdFilterTrackEnabled = false;
    this.thresholdConfigSettingsObj.linkedFilterAction = false;
    this.thresholdConfigSettingsObj.currentStateCheckBox = false;
  }

  close() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer);
      this.progressTimer = null;
    }
    this.tts.remove();
    this.dialogRef.close();
  }


  btnProceedCombineHandler() {
    const self = this;
    this.showSpinner = true;
    // former checkForBlockingJobInProgress
    this.irbOrderService.checkIfBlockingJobInProgress().subscribe((data: any) => {
      self.showSpinner = false;
      const sData = data ? data.toString().toUpperCase() : 'NO_DATA';
      if(sData === 'NO_JOB_EXECUTION' || sData === 'COMPLETED') {
        self.proceedFunc();
      } else if (sData === 'STOPPING') {
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          dTitle: 'Create Blocks',
          dProceedBtnLabel: '',
          msg: 'The Create Blocks process is being canceled. Please wait and then try again.The Create Blocks process is being canceled. Please wait and then try again.',
          onProceed: () => {}
        } as IAlertDialogData);
      } else if (sData === 'NO_DATA') {
        self.showSpinner = false;
        //console.log('err', 'Progress status is unavailable');
      } else {
        self.combinedWarningTitle = 'Create Blocks'
        self.combinedWarningMsg = 'You have already initiated a Create Blocks process on a large number of orders.';
        self.combinedWarningAltMsg = 'Please wait until this process completes or choose to cancel it.';
        self.combinedWarningCallbackFn = function() {
          self.close();
        };
        this.combinedWarningCancelCallbackFn = function() {
          self.stopBlockingJob();
          self.close();
        };
        self.combinedWarningBtnTitle = 'Allow Process to Complete';
        self.combinedWarningCancelBtnTitle = 'Cancel Process';
        self.step = 'show-combine-warning';
        if (typeof self.dialogRef.updateSize === 'function') {
          self.dialogRef.updateSize('500px', '200px');
        }
      }
    }, () => {
      self.showSpinner = false;
      self.close();
    });
  }

  proceedFunc() {
    const self = this;
    self.showSpinner = true;
    const someOrdersChecked = (self.inventoryComponentRef.params.api.getSelectedRows().length > 0);
    const isAboveThreshold = self.thresholdConfigSettingsObj.totalRecords > self.thresholdConfigSettingsObj.thresholdCount;

    if (self.thresholdConfigSettingsObj.isSelectAll) {
      // check for filters
      if (self.inventoryComponentRef.totalRecordsFromServer === self.thresholdConfigSettingsObj.totalRecords) { // combine all
        self.irbOrderService.checkAllBlockOrdersCount().subscribe((resp: any) => {
          if (resp.responseStatus === 'SUCCESS') {
            const ordersCnt = resp.responseData;
            this.combineAll(ordersCnt, isAboveThreshold);
          }
        }, () => {
          self.close();
        });

      } else { //combine selected
        self.inventoryComponentRef.getRecordsFromInventory((context: any, selectedArr: any) => {
          false && console.log('getRecordsFromInventory context: ', context);
          self.getRecordsFromInventoryCallback(selectedArr);
        });
      }
    } else {
      if (someOrdersChecked) {
        self.inventoryComponentRef.getRecordsFromInventory((context: any, selectedArr: any) => {
          false && console.log('getRecordsFromInventory context: ', context);
          self.getRecordsFromInventoryCallback(selectedArr);
        });
      } else { //combine all
        self.irbOrderService.checkAllBlockOrdersCount().subscribe((resp: any) => {

          if (resp.responseStatus === 'SUCCESS') {
            const ordersCnt = resp.responseData;
            this.combineAll(ordersCnt, isAboveThreshold);
          }
        }, () => {
          self.close();
        });
      }
    }
  }
  combinedWarningCallbackFnExec(async: boolean) {
    if (async) {
      this.combineNoSelDialog();
    } else {
      this.combineAllOrders();
    }
  }
  combineAll(ordersCnt: number, async: boolean) {
    const self = this;
    self.showSpinner = false;
    if (ordersCnt > 0) {
      self.warningOrderCnt = ordersCnt;
      self.inventoryComponentRef.ordersSupportDetails.warningOrders = ordersCnt;
      self.combinedWarningMsg = self.getCombineWarningMessage(ordersCnt);
      self.combinedWarningCallbackFn = () => {
       this.combinedWarningCallbackFnExec(async);
      };
      self.combinedWarningBtnTitle = 'Combine all';
      self.step = 'show-combine-warning';
      if (typeof self.dialogRef.updateSize === 'function') {
        self.dialogRef.updateSize('500px', '200px');
      }
    } else {
      if (async) {
        self.combineNoSelDialog();
      } else {
        self.combineAllOrders();
      }
    }
  }

  getCombineWarningMessage(ordersCnt: number) {
    const self = this;
    const selectedOrderCount = ordersCnt;
    const adjustedOrderCount = selectedOrderCount - self.warningOrderCnt;
    return ' ' + (self.warningOrderCnt === 1 ? 'Order': 'Orders')
      + ' must be in a Validated or Overridden status to be included in a block trade. ' + adjustedOrderCount + ' of ' + selectedOrderCount + ' orders will be combined.';
  }

  getRecordsFromInventoryCallback(selectedArr: any) {
    let encodeQueryParam: string;

    const filter = this.inventoryComponentRef.pfs._filterCriteria;
    if (filter != null) {
      encodeQueryParam = filter.replace('&Filter=%26', '');//encodeURIComponent(filter);
    } else {
      encodeQueryParam = '';
    }
    let selectAllState: boolean;
    if (this.thresholdConfigSettingsObj.isSelectAll || selectedArr.length === this.thresholdConfigSettingsObj.totalRecords) {
      selectAllState = true;
    } else {
      selectAllState = false;
    }
    let dataToPost = {
      selectAllFlag: selectAllState,
      resolvedOnly: false,
      deselectedIds: this.thresholdConfigSettingsObj.deselectedIds
    };
    if (selectedArr.length === 0) {
      // unreachable because callback won't executed
    } else if (selectedArr.length > 1) {
      this.showSpinner = false;
      const ordersArr: any[] = [];
      selectedArr.forEach((entry: any) => {
        const order: any = {};
        order.orderID = entry.orderID;
        order.versionId = entry.versionId;
        ordersArr.push(order);

        if (["WARNING","APPROVED","ERROR","ON_HOLD"].indexOf(entry.orderStatus.toUpperCase()) !== -1) {
          this.warningOrderCnt++;
        }
      });
      if (this.warningOrderCnt > 0) {
        // showCombineWarningsDialog(warningOrderCnt, "combineSelected", ordersArr);
        this.inventoryComponentRef.ordersSupportDetails.warningOrders = this.warningOrderCnt;
        this.combinedWarningMsg = this.getCombineWarningMessage(selectedArr.length);
        this.combinedWarningCallbackFn = function () {
          if(ordersArr.length > this.thresholdConfigSettingsObj.thresholdCount) {
            this.combineAsynSelectedCallFun(dataToPost, encodeQueryParam);
          } else {
            this.combineSelectedOrders(ordersArr);
          }
        };
        this.combinedWarningBtnTitle = 'Combine Selected';
        // this.combinedWarningData = ordersArr; //todo: check if need to show orders in a grid
        this.step = 'show-combine-warning';
        if (typeof this.dialogRef.updateSize === 'function') {
          this.dialogRef.updateSize('500px', '200px');
        }
      } else {
        if(ordersArr.length > this.thresholdConfigSettingsObj.thresholdCount) {
          this.combineAsynSelectedCallFun(dataToPost, encodeQueryParam);
        } else {
          this.combineSelectedOrders(ordersArr);
        }
      }
    } else {
      this.showSpinner = false;
      this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        dType: 'WARN',
        dTitle: '',
        dProceedBtnLabel: '',
        msg: 'An individual record can not be combined.',
        onProceed: () => {
        }
      } as IAlertDialogData);
      this.close();
    }

  }
  /**
   * @description Allow the user to cancel existing create blocks process.
   * @since IREBALOPNS-2234
   * @return {dojo.Deferred}
   */
  stopBlockingJob() {
    this.irbOrderService.stopBlockingJob().subscribe((data: any) => {
      const sData = data.toString().toUpperCase();
      if(sData === 'STOPPING') {
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          dType: 'WARN',
          dTitle: 'Create Blocks',
          dProceedBtnLabel: 'Ok',
          msg: 'The Create Blocks process is being canceled. Please wait and then try again.',
          onProceed: () => {
          }
        } as IAlertDialogData);

      } else if(sData === 'STOPPED') {
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          dType: 'WARN',
          dTitle: 'Create Blocks',
          dProceedBtnLabel: 'Ok',
          msg: 'The Create Blocks process has been successfully canceled.',
          onProceed: () => {
          }
        } as IAlertDialogData);
      } else {
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          dType: 'WARN',
          dTitle: 'Create Blocks',
          dProceedBtnLabel: 'Ok',
          msg: 'The Create Blocks process could not be canceled.',
          onProceed: () => {
          }
        } as IAlertDialogData);
      }
    },
      () => {
      this.close();
    });

  }

  combineAllOrders() {
    const self = this;
    self.showSpinner = true;
    let postData = {
      masterAccount :this.selectedMasterAccount.name
    }

    self.irbOrderService.combineAllOrders(postData).subscribe((response: any) => {
      //self.showSpinner = false;
      if (!response) {
        self.showSpinner = false;
        response = {};
        response.responseStatus = 'ERROR';
        response.responseUtilityMap = {};
        response.responseUtilityMap.Message = 'Server returned no data';
      }
      self.close();
      if (response.responseStatus === "SUCCESS") {
        if (response.responseData) {

          if (response.responseUtilityMap && response.responseUtilityMap.blockOrderIds && response.responseUtilityMap.blockOrderIds.length) {
            this.updateOrderTradeVol(response.responseUtilityMap.blockOrderIds);
          } else {
            self.showSpinner = false;
            self.close();
            self.refreshBlotter();
            self.defaultSettingsThreshold();
          }
        } else {
          self.close();
          self.showSpinner = false;
          this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dType: 'ERROR',
            dTitle: '',
            dProceedBtnLabel: '',
            msg: response.responseUtilityMap.Message,
            onProceed: () => {
            }
          } as IAlertDialogData);

        }
      } else if (response.responseStatus === "STALEDATAEXCEPTION") {
        self.close();
        self.showSpinner = false;
        this.staleDataOccured({
          "action": function () {
            self.defaultSettingsThreshold();
            self.refreshBlotter();
          },
          "msg": "Please refresh the page.",
          "btnLabel": "Refresh",
          "title": "Refresh Required"
        });
      } else {
        self.close();
        self.showSpinner = false;
        self.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          dType: 'ERROR',
          dTitle: 'Error',
          dProceedBtnLabel: '',
          msg: response.responseUtilityMap.Message,
          onProceed: () => {
          }

        } as IAlertDialogData);
      }
    },
    () => {
      self.showSpinner = false;
      this.close();
    });
  }
  staleDataOccured(payload: any) {
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dTitle: payload.title,
      dProceedBtnLabel: payload.btnLabel,
      msg: payload.msg,
      onProceed: () => { payload.action();}
    } as IAlertDialogData);
  }
  combineSelectedOrders(ordersArr: any) {
    const self = this;
    self.showSpinner = true;

    let requestObj = {
      orderBlotterDTOList : ordersArr,
      masterAccount :this.selectedMasterAccount.name
    };

    self.irbOrderService.combineSelectedOrders(requestObj).subscribe((response: any) => {
      //self.showSpinner = false;
      //self.close();

      if (response.responseStatus === "SUCCESS") {
        if (response.responseData) {
          if (response.responseUtilityMap && response.responseUtilityMap.blockOrderIds && response.responseUtilityMap.blockOrderIds.length) {
            this.updateOrderTradeVol(response.responseUtilityMap.blockOrderIds);
          } else {
            self.showSpinner = false;
            self.close();
            self.refreshBlotter();
            self.defaultSettingsThreshold();
          }
        } else {
          self.showSpinner = false;
          self.close();
          self.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dTitle: 'Create Blocks',
            dProceedBtnLabel: '',
            msg: response.responseUtilityMap.Message,
            onProceed: () => {
            }
          } as IAlertDialogData);
        }
      } else if (response.responseStatus === "STALEDATAEXCEPTION") {
        self.showSpinner = false;
        self.close();
        self.staleDataOccured({
          action: () => {
            self.refreshBlotter();
            self.defaultSettingsThreshold();
          },
          msg: 'Please refresh the page.',
          btnLabel: 'Refresh',
          title: 'Refresh Required'
        });

      } else {
        self.showSpinner = false;
        self.close();
        self.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          dTitle: 'Create Blocks',
          dProceedBtnLabel: '',
          msg: response.responseUtilityMap.Message,
          onProceed: () => {
          }
        } as IAlertDialogData);
      }
    }, () => {
      self.showSpinner = false;
      self.close();
    });
  }

  updateOrderTradeVol(blockOrderIds: any) {
    this.irbOrderService.updateOrderTradeVol(blockOrderIds).subscribe((response: any) => {
      this.showSpinner = false;
      this.close();
      if (response.responseStatus === "SUCCESS") {
        this.refreshBlotter();
        this.defaultSettingsThreshold();
      } else if (response.responseStatus === "STALEDATAEXCEPTION") {
        this.staleDataOccured({
          action: () => {
            this.refreshBlotter();
            this.defaultSettingsThreshold();
          },
          msg: 'Please refresh the page.',
          btnLabel: 'Refresh',
          title: 'Refresh Required'
        });
      } else {
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          dTitle: 'Create Blocks',
          dProceedBtnLabel: '',
          msg: response.responseUtilityMap.Message,
          onProceed: () => {
          }
        } as IAlertDialogData);
      }
    }, () => {
      this.showSpinner = false;
      this.close();
    });
  }


  combineAsynSelectedCallFun(dataToPost: any, filter: string) {
    const self = this;
    self.showSpinner = true;
    dataToPost.masterAccount = this.selectedMasterAccount.name;
    self.irbOrderService.combineAsynSelectedCall(dataToPost, filter).subscribe((response: any) => {
      self.showSpinner = false;
      self.progressBarInitiate();
      self.getOrderStatusUpdate(response.responseUtilityMap.ordStatUpdId);
    }, () => {
        self.showSpinner = false;
        self.close();
    });
  }
  getOrderStatusUpdate(idRef: string, blockDeskCount?: string|number) {
    const self = this;
    self.irbOrderService.getOrderStatusUpdate(idRef).subscribe((response: any) => {

      //TODO: Check with MT and handle all error types
      const reqStatus = response.reqStatus.toUpperCase();
      if (reqStatus === 'FAILED') { // This msg for create block order to check warnings status
        self.hideProgressBarContainer();
        self.close();
        self.defaultSettingsThreshold();
        self.refreshBlotter();
        self.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          dType: 'ERROR',
          dTitle: '',
          dProceedBtnLabel: '',
          msg: response.failMsg,
          onProceed: () => {}
        } as IAlertDialogData);
        self.showSpinner = false;
      } else if (reqStatus === 'STARTED' || reqStatus === 'IN_PROGRESS' || reqStatus === 'STOPPING') { //TODO: check proper value with MT
        self.updateProgressBarStatus(response);

      } else if (reqStatus === 'COMPLETED') {
        self.showSpinner = false;
        self.close();
        if (Number(blockDeskCount)) {
          self.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dType: 'WARN',
            dTitle: '',
            dProceedBtnLabel: '',
            msg: 'Your order has been sent to the block desk. Please refresh your order blotter to confirm that an order ID was received. If accepted, you should receive a call from the block desk at the number you provided. If you do not receive a call back within the next 2 minutes, please call the block desk at ' + this.blockDeskContact,
            onProceed: () => {}
          } as IAlertDialogData);
        }

        self.defaultSettingsThreshold(); // default settings for threshold config after completion.
        self.hideProgressBarContainer();
        //this.clearSessionObject("grid_blotterGridDiv"); todo: implement if needed
        self.refreshBlotter();//added for IREBALUX-4003

      } else if (response.reqStatus === "STOPPED") {
        self.hideProgressBarContainer();
        self.close();
        self.defaultSettingsThreshold();
        self.combinedWarningMsg = 'Block job execution was stopped by another user in the environment.';
        self.combinedWarningCallbackFn = function (event: any) {
          event.target.disabled = true;
          self.refreshBlotter();
        };
        self.combinedWarningBtnTitle = 'Refresh Blotter';
        self.showSpinner = false;
        self.step = 'show-combine-warning';
        if (typeof self.dialogRef.updateSize === 'function') {
          self.dialogRef.updateSize('500px', '200px');
        }
      }
    }, function () {
      self.showSpinner = false;
      self.close();
    });
  }

  thresholdLimitBoolean(condType: string = '', mixedCheckChecked: string = ''): boolean {
    const objRef = this.thresholdConfigSettingsObj;


    const filterCountCheck = (objRef.isFilterAppliedCount > 1) ? true : false;
    const thresholdCount = (condType === "Export") ? objRef.thresholdExportCount : objRef.thresholdCount
    const thresholdCountFlag = (objRef.selectedRecords <= thresholdCount) ? true : false;
    let finalResult;

    if (condType === "showAlertSelAllFilterMult") {

      let selectedRecords = objRef.selectedRecords;
      let currentUpdate = selectedRecords + this.thresholdConfigSettingsObj.totalRecords;

      if (objRef.selectedRecords === 0) {

        objRef.selectedRecords = this.thresholdConfigSettingsObj.totalRecords;
        objRef.deselectedRecords = 0;
        finalResult = false;
        if (objRef.isFilterApplied) {
          objRef.mixedWithSelectedAll = true;
        }

          // false && console.log(mixedCheckChecked, 1);

      } else if (currentUpdate > thresholdCount && (mixedCheckChecked === "cb" || (mixedCheckChecked === "cbMixed" && (objRef["isSelectAll"] || !objRef["mixedWithSelectedAll"])))) {

        finalResult = true;

          // false && console.log(mixedCheckChecked, 2);
      } else if (currentUpdate < thresholdCount && mixedCheckChecked === "cb") {
        objRef.selectedRecords = currentUpdate;
        finalResult = false;
        objRef.deselectedRecords = 0;
          // false && console.log(mixedCheckChecked, 3);
      } else if(mixedCheckChecked === "cbMixed" && objRef.isFilterApplied && objRef.selectedRecords > 0 && !objRef.mixedWithSelectedAll) {

      objRef.selectedRecords = objRef.selectedRecords + (this.thresholdConfigSettingsObj.totalRecords - objRef.deselectedRecords);
      objRef.selectedRecords = objRef.selectedRecords < 0?0:objRef.selectedRecords;
      finalResult = false;
      objRef.mixedWithSelectedAll = true;
          // console.log(mixedCheckChecked,4);
      } else if (mixedCheckChecked === "cbMixed" && !objRef["currentStateCheckBox"]) {
        objRef.selectedRecords = objRef.selectedRecords + (this.thresholdConfigSettingsObj.totalRecords - objRef.deselectedRecords);
        objRef.selectedRecords = objRef.selectedRecords < 0 ? 0 : objRef.selectedRecords;
        finalResult = false;
        objRef.mixedWithSelectedAll = true;
        objRef.isSelectAll = false;
        this.isSelecting = true;
          // false && console.log(mixedCheckChecked, 40);
      } else if (mixedCheckChecked === "cbMixed" && objRef.currentStateCheckBox) {
        objRef.mixedWithSelectedAll = false;
        objRef.selectedRecords = objRef.selectedRecords - (this.thresholdConfigSettingsObj.totalRecords - objRef.deselectedRecords);
        objRef["selectedRecords"] = objRef["selectedRecords"] < 0 ? 0 : objRef["selectedRecords"];
        finalResult = false;

          // false && console.log(mixedCheckChecked, 41);

      } else if (mixedCheckChecked === "cbChecked") {

        objRef.selectedRecords = selectedRecords - this.thresholdConfigSettingsObj.totalRecords;
        objRef.selectedRecords = objRef.selectedRecords < 0 ? 0 : objRef.selectedRecords;
        objRef.deselectedRecords = 0;
        objRef.isSelectAll = false;
        finalResult = false;
          // console.log(mixedCheckChecked, 5);
      }
    } else if (condType === "showAlert") {
      finalResult = !((objRef.selectedRecords < thresholdCount) ? true : false);
    } else if (condType === "filterCountCheck") {
      if (filterCountCheck && !thresholdCountFlag) {
        finalResult = true;
      } else {
        //sa 2021-03-01 ??????
      }
    } else {
      finalResult = thresholdCountFlag;
    }
    return finalResult;

  }

  combineNoSelOrdCall(orders: number) {
    const self = this;
    self.showSpinner = false;
    if (Number(orders) > 0) {
      self.warningOrderCnt = orders;
      self.inventoryComponentRef.ordersSupportDetails.warningOrders = orders;
      self.combinedWarningMsg = ' ' + self.warningOrderCnt + ' '
        + (self.warningOrderCnt === 1 ? 'order': 'orders')
        + ' in this block order are in warning status. If you continue and combine orders, '
        + 'these orders may get included in the block\'s allocation.';
      self.combinedWarningCallbackFn = function () {
        self.combineNoSelDialog();
      };
      self.combinedWarningBtnTitle = 'Combine all';
      self.step = 'show-combine-warning';
      if (typeof self.dialogRef.updateSize === 'function') {
        self.dialogRef.updateSize('500px', '200px');
      }
    } else {
      self.combineNoSelDialog();
    }
  }
  combineNoSelDialog() {
    const self = this;
    self.showSpinner = true;
    let ordersArr = {
      masterAccount :this.selectedMasterAccount.name
    }
    self.irbOrderService.combineAllBlockOrderAsynch(ordersArr).subscribe((response: any) => {
        self.showSpinner = false;
        self.progressBarInitiate();
        self.getOrderStatusUpdate(response.responseUtilityMap.ordStatUpdId);
    },
      () => {
        self.showSpinner = false;
        self.close();
    });
  }

  unblockOrdersInit() {
    const self = this;
    self.showSpinner = true;
    let noBlockText = "0 selected orders can be unblocked."
    self.inventoryComponentRef.getRecordsFromInventory((context: any, selectedArr: any) => {
      self.showSpinner = false;
      false && console.log(context);
      self.unblockOrdersInitCallback(selectedArr);
    });
  }
  unblockOrdersInitCallback(selectedArr: any) {
    const self = this;
    self.showSpinner = false;
    self.selectedArray = selectedArr || [];
    let blockOrdersGridDivHeight = "";
    if (self.selectedArray.length > 0) {
      self.step = 'show-unblock-orders';
      self.btnRevertBlockShow = true;
      self.btnUnblockCancelShow = true;
      self.selectedArray.forEach( (entry: any) => {
        const isParent = entry.isBlockOrder;
        if (isParent && isParent != null && (entry.orderStatus === "APPROVED" || entry.orderStatus === "VALIDATED" || entry.orderStatus === "OVERRIDDEN"
          || entry.orderStatus === "WARNING" || entry.orderStatus === "ERROR")) {
          self.unblockOrdersArr.push(entry);
        }
      });
      if (self.unblockOrdersArr.length > 0) {
        self.btnRevertBlockShow = true;
        self.btnUnblockCancelShow = true;
        self.unblockOrdersRowData = this.unblockOrdersArr;
      } else {
        self.btnRevertBlockShow = false;
        self.btnUnblockCloseShow = true;
        self.btnUnblockCancelShow = false;
      }
    } else {
      self.btnRevertBlockShow = false;
      self.btnUnblockCloseShow = true;
      self.btnUnblockCancelShow = false;
    }

  }
  btnRevertBlockHandle() {

    const self = this;
    this.showSpinner = true;
    const r = this.unblockOrdersArr.map((entry: any) => {return {orderID: entry.orderID, versionId: entry.versionId}});

    this.irbOrderService.unblockSelectedOrders(r).subscribe((response: any) => {
      if (!response) {
        response = {};
      }
      /// response.responseStatus = 'STALEDATAEXCEPTION'; todo: test line - remove
      self.unblockSelectedOrdersHandler(response);
    }, () => {
      self.showSpinner = false;
      self.close();
    });
  }
  unblockSelectedOrdersHandler(response: any) {
    const self = this;
    if (response.responseStatus === "SUCCESS") {
      // clearSessionObject("grid_blotterGridDiv"); todo: implement if needed
      self.refreshBlotter();
      self.defaultSettingsThreshold();
      self.showSpinner = false;
      self.close();
      self.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        dTitle: 'Order(s) Unblocked',
        dProceedBtnLabel: 'Close',
        msg: response.responseUtilityMap.Message,
        onProceed: () => {}
      } as IAlertDialogData);
    } else if (response.responseStatus === "STALEDATAEXCEPTION") {
      self.showSpinner = false;
      self.close();
      self.staleDataOccured({
        "action": function () {
          self.refreshBlotter();
          self.defaultSettingsThreshold();
        },
        "msg": "You are attempting to edit an order that was just modified by someone else. To see the updated order, you need to refresh the page.",
        "btnLabel": "Refresh",
        "title": "Refresh Required"
      });
    } else {
      self.showSpinner = false;
      self.close();
      self.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        dType: 'ERROR',
        dTitle: 'Create Blocks',
        dProceedBtnLabel: 'Close',
        msg: 'Error occurred.',
        onProceed: () => {
        }
      } as IAlertDialogData);
    }
  }

  getUnblockColumnDefs() {
    return [
      {
        headerName: 'Trans Type',
        suppressFiltersToolPanel: true,
        field: 'accountNumber',
        cellRenderer: (params: any) => {
          return formatTransactionAction(params.value);
        }
      },
      {
        headerName: 'Symbol',
        suppressFiltersToolPanel: true,
        field: 'securitySymbol',
        cellRenderer: (params: any) => {
          return (params.value ? params.value : '0');
        }
      },
      {
        headerName: 'Quantity',
        suppressFiltersToolPanel: true,
        field: 'quantity'
      },
      {
        headerName: 'Order Type',
        suppressFiltersToolPanel: true,
        field: 'orderType',
        cellRenderer: (params: any) => {
          return formatOrderType(params.value);
        }
      },
      {
        headerName: 'Expiration',
        suppressFiltersToolPanel: true,
        field: 'expirationDate',
        cellRenderer: (params: any) => {
          return ((params.value && params.value != null) ? this.formatEasternDate(params.value, "-") : 'n/a');
        }
      },
    ];

  }
  formatEasternDate(item: any, separator: string) {
    if (item && item != null) {
      const estTime = this.getEasternTime(item);
      const estMonth = estTime.getMonth()+1;
      const estDate = estTime.getDate();
      const returnItem = "" + ((estMonth < 10) ? ("0"+estMonth) : estMonth) + separator + ((estDate < 10) ? ("0"+estDate) : estDate) + separator + estTime.getFullYear();
      return returnItem;
    } else
      return "";
  }
  getEasternTime(item: any) {
    const jan = new Date(new Date().getFullYear(), 0, 1);
    const jul = new Date(new Date().getFullYear(), 6, 1);
    const offSet = (new Date().getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())) ? -4 : -5;
    return (new Date(item + (new Date().getTimezoneOffset() * 60000)+ (3600000*offSet)));
  }

  hideProgressBarContainer() {
    this.inventoryComponentRef.pfs.progressBarValue = -1;
    if (this.progressTimer) {
      clearTimeout(this.progressTimer);
    }

  }

  progressBarInitiate() {
    this.step = 'show-progress-bar';
    this.inventoryComponentRef.pfs.progressBarValue = 0;
    this.updateStatusCount = 0
  }

  updateProgressBarStatus( response: any) {
    const self = this;
    const cnt = response.failedRecCount + response.successRecCount;
    const rcnt = response.recievedCount;
    if (rcnt > 0) {
      const progressPercentage = Math.floor((cnt * 100) / rcnt);
      self.inventoryComponentRef.pfs.progressBarValue = progressPercentage;
    }
    const timeout = (self.updateStatusCount > 10) ? 10000 : (self.updateStatusCount > 2) ? 5000 : 3000;
    self.updateStatusCount++;
    self.progressTimer = setTimeout(function () {
      self.getOrderStatusUpdate(response.statusUpdateId);
    }, timeout);
  }

  refreshBlotter() {
    this.inventoryComponentRef.refreshGrid();
  }

  getMasterAccount() {
    if(this.masterAccountList === undefined || this.masterAccountList.length === 0) {
      this.irbOrderService.getMasterAccount().subscribe((res: any) => {
        if (res.responseStatus === "SUCCESS") {
          this.masterAccountList = res.responseData;
          const selectedValue =  this.masterAccountList.filter(obj => obj.isSelected === true);
          
          if(selectedValue !=null && selectedValue.length >0){
            this.selectedMasterAccount = selectedValue[(selectedValue.length-1)];
            this.canNotContinue = false;
          }

          this.populateMasterAccountDropdown();
        }
      });
    } else {
      this.populateMasterAccountDropdown();
    }
  }

  populateMasterAccountDropdown() {
    let f: Array<IDropdownItem> = [];
    let items: IDropdownItem[] = [];

    this.masterAccountList?.forEach((x:IMasterAccount)=>{
      items.push({name: x.name, value: x});
    });

    f = [].concat(items);
    
    if(this.masterAccountTemplateRef){
      this.masterAccountTemplateRef.set(f);
    }
  }

 selectOption(event: IDropdownItem) {
  this.masterAccountTemplateRef.setValue(event);
  this.canNotContinue = false;
 }
}

